import { useModulePageDetails } from "modules/brands/pages/ModulesContainer/components/PageModules/components/ModuleDetailsDrawer/context";
import { useGeneralData } from "modules/brands/pages/ModulesContainer/components/PageModules/components/ModuleDetailsDrawer/stores/useGeneralData";
import { type FC } from "react";
import OneCardBlockForm from "./components/OneCardBlockForm";

const OneCardBlockConfig: FC = () => {
  const { oneCardsLoadingQueries } = useModulePageDetails();
  const { contentBlocks } = useGeneralData();

  if (!contentBlocks || !contentBlocks.length) {
    return null;
  }

  return (
    <>
      {contentBlocks.map((item, index) => (
        <OneCardBlockForm
          key={index}
          item={item}
          index={index}
          isLoadingFile={oneCardsLoadingQueries[index]}
        />
      ))}
    </>
  );
};

export default OneCardBlockConfig;
